import ActionTypes from '../ActionTypes';

export function toggleNewTraveler(value) {
  return {
    type: ActionTypes.Inquiry.toggleNewTraveler,
    value,
  };
}

export function addTraveler(traveler) {
  return {
    type: ActionTypes.Inquiry.addTraveler,
    traveler,
  };
}

export function moveTraveler(start, end) {
  return {
    type: ActionTypes.Inquiry.moveTraveler,
    start,
    end,
  };
}

export function removeTraveler(index) {
  return {
    type: ActionTypes.Inquiry.removeTraveler,
    index,
  };
}

export function removeSegment(index) {
  return {
    type: ActionTypes.Inquiry.removeSegment,
    index,
  };
}

export function updateField(field, value) {
  return {
    type: ActionTypes.Inquiry.updateField,
    field,
    value,
  };
}

export function addSegment(segment) {
  return {
    type: ActionTypes.Inquiry.addSegment,
    segment,
  };
}

export function resetInquiryForm() {
  return {
    type: ActionTypes.Inquiry.resetInquiryForm,
  };
}



// WEBPACK FOOTER //
// /src/store/actions/InquiryActions.js